import { camelizeObject } from '@cvt/helpers/object';

export const mapMajorData = (data: Majors.MajorApi): Majors.Major => {
  const major = camelizeObject<Majors.Major>(data);
  return {
    ...major,
    match: {
      ...major.match,
      value: (major.match?.value || 0) / 100,
    },
  };
};
